const forceRefreshOnce = () => {
    const refreshRequired = sessionStorage.getItem("hasRefreshed");
    if (!refreshRequired) {
      sessionStorage.setItem("hasRefreshed", "true");
      window.location.reload();
    }
  };
  
  export default forceRefreshOnce;
  